import { faChevronDown, faChevronRight, faChevronUp } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Collapse, LinearProgress, Typography } from "@mui/material";
import { useState } from "react";
import { sxWhiteTextButton } from "../../../../assets/styles/CommonSxProps";
import { MeuProgresso } from "../../../../interfaces/entities/SaudeBemEstar/GestaoDeCronicos/MeuProgresso";
import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";
import './styles.css';
import { sxProgressBar } from "./sxProps";

const ProgressCard: React.FC<{ progress: MeuProgresso, viewCompleteSchedule: () => void }> = ({
  progress, viewCompleteSchedule
}) => {

  const [showProgressDetails, setShowProgressDetails] = useState<boolean>(false);
  const accessibility = useAccessibility();

  const handleClickVerCronogramaCompleto = (e: React.MouseEvent) => {
    e.stopPropagation();
    viewCompleteSchedule();
  }

  const handleOpenProgressCardOnKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      setShowProgressDetails(show => !show)
    }
  }

  const handleViewCronogramaCompletoOnKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.stopPropagation();
      viewCompleteSchedule();
    }
  }

  return (
    <div className="general-progress-card" tabIndex={0} onClick={() => setShowProgressDetails(show => !show)}
      style={{ ...accessibility.contrastStyle, border: accessibility.contrastMode ? '1px solid white' : '' }}
       onKeyDown={handleOpenProgressCardOnKeyDown}
    >
      <div className="general-progress-card-header" >
        <Typography fontWeight={'700'}>Progresso geral</Typography>
        <FontAwesomeIcon color='#ffffff' icon={showProgressDetails ? faChevronUp : faChevronDown} />
      </div>
      <Collapse in={showProgressDetails} timeout="auto" unmountOnExit>
        <div className="general-progress-card-body">
          <div className="progress-details-container">
            <div className="progress-details">
              <Typography fontWeight={'700'} fontSize={'28px'}>{progress.percentualConcluido}%</Typography>
              <Typography fontSize={'16px'}>Você está no dia {progress.diaAtual} de {progress.totalDias}</Typography>
            </div>
            <Button
              sx={sxWhiteTextButton}
              onClick={(e) => handleClickVerCronogramaCompleto(e)}
              onKeyDown={handleViewCronogramaCompletoOnKeyDown}
            >
              <u>ver cronograma completo</u>&nbsp;&nbsp;<FontAwesomeIcon icon={faChevronRight} />
            </Button>
          </div>
          <div>
            <LinearProgress sx={sxProgressBar} variant="determinate"
              value={Number(progress.percentualConcluido)} style={accessibility.contrastStyle}
            />
            <div className="flex-row space-between">
              <Typography fontWeight={'600'} fontSize={'16px'}>
                {progress.percentualConcluido}%
              </Typography>
              <Typography fontWeight={'600'} fontSize={'16px'}>
                100%
              </Typography>
            </div>
          </div>
        </div>
      </Collapse>
    </div>
  );
}

export default ProgressCard;
